
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.39 0H1.946C.959 0 .168.8.168 1.778v12.444C.168 15.2.959 16 1.946 16H14.39c.978 0 1.778-.8 1.778-1.778V1.778C16.168.8 15.368 0 14.39 0zm0 14.222H1.946V1.778H14.39v12.444zm-5.333-1.778H7.279V8.89H3.724V7.11h3.555V3.556h1.778V7.11h3.555V8.89H9.057v3.555z","fill":"#585858"}})])
          )
        }
      }
    